import React, { useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import * as _ from 'lodash';
import { useReactOidc } from '@axa-fr/react-oidc-context';
import './styles.scss';
import { config } from '../../utils/config';
import { setAuthHeader } from '../../api/api'
import { getCustomerDetails } from '../../api/customer';
import { MenuBar } from '@metaforcelabs/metaforce-core';

const Oidc = () => {
  const navigate = useNavigate();
  const { oidcUser } = useReactOidc();

  useEffect(() => {
    if (oidcUser) {
      setAuthHeader(oidcUser.access_token)
      validateLicense()
    }
  }, [oidcUser])



  const validateLicense = async () => {
    const customerDetails = await getCustomerDetails()
    const hasLicense = customerDetails?.activeProducts?.find(a => a.id === config.productLicense)
    if (hasLicense) {
      // The oidc library already pushed history to the page the sign-in link pointed to
      // (user.state.url) before this effect ran. Re-push the current location instead of '/' so
      // that restore survives, while still leaving this screen to prevent a blank hang.
      navigate(window.location.pathname + window.location.search);
    }
    else {
      navigate('/missing-license');
    }
  }

  const navigationMenu = [
    {
      linkElement: <Link to="/home">Home</Link>,
      name: "Home",
      current: true,
      featureEnabled: true
    }
  ];


  return (
    <div className="relative min-h-screen flex flex-col bg-white">
      <MenuBar
            navigation={navigationMenu}
            homeButtonLink={config?.centerpointUiBaseUrl}
        />

        <main className="main-container bg-gray-50 flex-1 z-0 focus:outline-none">
          <div className="max-w-screen-2xl mx-auto inset-0 py-6 px-4 sm:px-6 lg:px-8">
            <div className="flex flex-col pb-10">
              <div className="max-w-screen-2xl">
              <p className="text-2xl font-bold mt-6">Loading...</p>
              </div>
            </div>
          </div>
        </main>
      </div>
  )
}

export default Oidc;